import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Introduction to the Freon Language Workbench",
description: "Learn what the Freon Language Workbench is, how it supports domain-specific language development, and what makes its projectional editor unique.",
tags: [ "introduction", "language workbench", "DSL", "projectional editing", "TypeScript", "metamodel", "validation", "editor"] ,
modifiedTime: "2025-11-07T18:12:52.262Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};